export default {
  system: {
    notAvaiable: {
      en: "System is not avaiable.",
      pt: "Sistema fora do ar.",
    },
    labelButton: {
      avaiable: {
        en: "Avaiable",
        pt: "Ativo",
      },
      disabled: {
        en: "Disabled",
        pt: "Inativo",
      },
    },
  },
};
